import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class IdfReportService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get IDF data
   * @returns Array
   */
  getData(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/reports/idf-report`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Filter IDF report by date & consignee
   */
  filter(startDate:any,endDate:any,consigneeId:any,agentId:any): Observable<ApiResponse>{
    const formData = new FormData();
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("consignee_id", consigneeId);
    formData.append("agent_id", agentId);

    let apiURL:string=`${this.baseURL}/v1/reports/idf-report/filter`;

    return this.http.post<ApiResponse>(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Export IDF report to Excel
   * @returns array
   */
  exportToExcel(startDate:any,endDate:any,consigneeId:any,agentId:any):Observable<any>{

    const formData = {
      start_date: startDate,
      end_date:endDate,
      consignee_id:consigneeId,
      agent_id:agentId
    };

    let apiURL:string=`${this.baseURL}/v1/reports/idf-report/export-to-excel`;

    return this.http.post(apiURL, formData, {
      headers: this.headers,
      responseType: 'blob' as 'json' // Expect binary file, not JSON
    }).pipe(catchError(this.errorHandler.handleError));
  }
}
